import { useState, useEffect, useRef } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Button } from '@wajeez-web/components/ui';
import { DownloadIcon, PlusIcon } from '@heroicons/react/solid';
import {
  AdminSystemPermissions,
  SuperAdminSystemPermissions,
} from '@wajeez-web/core/types';
import { useNavigate } from 'react-router-dom';
import { convertMarkdownToHtml } from '@wajeez-web/core/utils';
import {
  useContentSelector,
  useContentDispatch,
  FlowsActions,
} from '@wajeez-web/stores/content';
import { DeleteItemAlert } from '@wajeez-web/components/ui';
import {
  CommonActions,
  AlertType,
  useCommonDispatch,
} from '@wajeez-web/stores/common';
import { Content, Server } from '@wajeez-web/core/api-base';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import _ from 'lodash';
import { DotsHorizontalIcon } from '@heroicons/react/outline';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { DataTable, Dropdown, CheckBoxType } from '@wajeez-web/components/mui';

import { CloneModal } from '../components/CloneModal';

const FlowsV2Page = () => {
  const navigate = useNavigate();

  const commonDispatch = useCommonDispatch();
  const contentDispatch = useContentDispatch();

  const exportDataRef = useRef<any>(null);

  const [flowModalState, setFlowModalState] = useState<{
    open: boolean;
    data?: Server.UpdateFlowInput;
  }>({ open: false, data: undefined });
  const [isCloneFlowModalOpen, setIsCloneFlowModalOpen] = useState(false);
  const [selectedFlowId, setSelectedFlowId] = useState<number>();

  const cloneFlow = useContentSelector(({ flows }) => flows.cloneFlow);

  const {
    tablePreferances,
    setTablePreferences,
    getData: getDatatableData,
    isTableReferencesLoading,
  } = HandleTableData(
    'flows',
    FlowsActions.getFlowsDatatableAsync,
    undefined,
    undefined,
    [{ property: 1, orderByDirection: 1 }]
  );

  const dataTableData = useContentSelector(({ flows }) => flows.flowsDatatable);

  const { t } = useTranslation();

  //   const handleExport = async () => {
  //     if (dataTableData && tablePreferances) {
  //       const res = await contentDispatch(
  //         AuthorsActions.getAuthorsToBeExportedAsync({
  //           ...tablePreferances,
  //           pageNumber: 1,
  //           pageSize: dataTableData.totalCount,
  //         })
  //       );
  //       if (res.meta.requestStatus === 'fulfilled') {
  //         exportDataRef.current.link.click();
  //       }
  //     }
  //   };

  //   const extractExportedData = () => {
  //     const d = [];

  //     if (dataTableData?.totalCount && dataTableData?.totalCount > 0) {
  //       for (let i = 0; i < dataTableData?.totalCount; i++) {
  //         const row: { [key: string]: any } = {};

  //         exportData?.['columns']?.forEach((item: any) => {
  //           if (!item.isHidden) {
  //             row[item.header] = item.cells[i];
  //           }
  //         });

  //         d.push(row);
  //       }
  //     }
  //     return d;
  //   };

  return (
    <>
      {/* <CSVLink
        filename={'Authors.csv'}
        data={extractExportedData()}
        ref={exportDataRef}
        className="hidden"
      >
        Download me
      </CSVLink> */}
      <PageLayoutsContainer
        title={`Flows V2`}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Add Flow'}
                Icon={PlusIcon}
                onClick={() => {
                  navigate('/flows/v2/new');
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: [SuperAdminSystemPermissions.flows.add],
          },
        ]}
        breadCrumbsLinks={[{ title: '' }]}
      >
        <DataTable
          dataTableData={dataTableData.data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          renderRowActions={(row) => {
            return (
              <div className="w-full flex justify-center items-center">
                <Dropdown
                  id={`action-${row[1]}`}
                  items={[
                    {
                      label: 'Edit',
                      onClick: () => {
                        navigate(`/flows/v2/${row[1]}/edit`);
                      },
                    },
                    {
                      label: 'Content',
                      onClick: () => {
                        navigate(`/flows/v2/${row[1]}/pages/0`);
                      },
                    },
                    {
                      label: 'Clone',
                      onClick: () => {
                        setSelectedFlowId(Number(row[1]) as number);
                        setIsCloneFlowModalOpen(true);
                      },
                    },
                  ]}
                  label={
                    <div style={{ color: '#343a40' }}>
                      <DotsHorizontalIcon
                        style={{ width: '28px', height: '24px' }}
                      />
                    </div>
                  }
                  buttonStyle={{
                    width: '34px',
                    minWidth: '34px',
                    paddingRight: '2px',
                    paddingLeft: '2px',
                    color: 'black',
                  }}
                />
              </div>
            );
          }}
          isLoading={dataTableData.status === 'loading'}
          //   extraActions={[
          //     {
          //       label: 'Export as CSV',
          //       onClick: () => {
          //         handleExport();
          //       },
          //       Icon: <DownloadIcon className="h-4 w-4" />,
          //     },
          //   ]}
        />
        {/* <Table
          isUpdating={
            datatableStatus === 'loading' ||
            updatingStatus === 'loading' ||
            exportDataStatus === 'loading'
          }
          isLoading={datatableStatus === 'loading'}
          setPreferances={setTablePreferences}
          PreferancesData={tablePreferances || undefined}
          tableData={dataTableData}
          columnsSelectors={(id, row) => {
            const about = convertMarkdownToHtml(row[16] || '');

            return {
              4: (
                <Button
                  type="text"
                  color="primary"
                  title={row[4]}
                  onClick={() => {
                    setAuthorModalState({
                      open: true,
                      data: {
                        id: row[1],
                        name: row[4],
                        originalName: row[8],
                        imageReference: row[2],
                        about: row[16],
                      },
                    });
                  }}
                />
              ),
              16: <div dangerouslySetInnerHTML={{ __html: about || '' }} />,
            };
          }}
          tableHeaderActions={(columns) => [
            {
              label: 'Export as CSV',
              onClick: () => {
                handleExport();
              },
              type: 'action',
              icon: <DownloadIcon className="h-4 w-4" />,
            },
          ]}
          tableActions={(id, row) => [
            {
              title: 'Edit',
              endpoint: '',
              permission: AdminSystemPermissions.authors.edit,
              type: 'request',
              action: () => {
                setAuthorModalState({
                  open: true,
                  data: {
                    id: row[1],
                    name: row[4],
                    originalName: row[8],
                    imageReference: row[2],
                    about: row[16],
                  },
                });
              },
            },
            {
              title: 'Content',
              permission: AdminSystemPermissions.authors.content,
              endpoint: ``,
              type: 'request',
              action: () => {
                navigate(`${row[1]}/content`);
              },
            },
            {
              title: 'Delete',
              endpoint: '',
              permission: AdminSystemPermissions.authors.delete,
              type: 'request',
              action: () =>
                DeleteItemAlert(
                  () =>
                    dispatch(
                      AuthorsActions.deleteAuthorAsync(parseInt(id))
                    ).then(() => getData()),
                  t('general.will delete') + row[4]
                ),
            },
          ]}
        /> */}
      </PageLayoutsContainer>
      {/* {
        <AuthorsModalComponent
          data={
            authorModalState.data && {
              about: authorModalState.data?.about,
              name: authorModalState.data?.name,
              originalName: authorModalState.data?.originalName,
              imageReference: authorModalState.data?.imageReference,
            }
          }
          isOpen={authorModalState.open}
          onClose={() => setAuthorModalState({ open: false, data: undefined })}
          onSubmit={async (data) => {
            if (data) {
              const res = authorModalState.data
                ? await contentDispatch(
                    AuthorsActions.editAuthorAsync({
                      id: authorModalState.data.id,
                      ...data,
                      languageId: 1,
                    })
                  )
                : await contentDispatch(
                    AuthorsActions.createNewAuthorAsync({
                      ...data,
                      languageId: 1,
                    })
                  );

              if (res.meta.requestStatus === 'fulfilled') {
                getData();

                await setAuthorModalState({ open: false, data: undefined });
                await commonDispatch(
                  CommonActions.setAlert({
                    type: AlertType.SUCCESS,
                    messages: [
                      { message: 'تمت العملية بنجاح', code: 200, field: '' },
                    ],
                    for: 'page',
                  })
                );
              }
            }
          }}
        />
      } */}
      {isCloneFlowModalOpen && (
        <CloneModal
          isOpen={isCloneFlowModalOpen}
          onClose={() => {
            setIsCloneFlowModalOpen(false);
          }}
          title="Clone Flow"
          onSave={async (name) => {
            const res = await contentDispatch(
              FlowsActions.cloneFlowAsync({
                flowName: name,
                id: selectedFlowId,
              })
            );

            if (res.meta.requestStatus === 'fulfilled') {
              setIsCloneFlowModalOpen(false);

              tablePreferances && setTablePreferences({ ...tablePreferances });
            }
          }}
          onSaveAndEdit={async (name) => {
            const res = await contentDispatch(
              FlowsActions.cloneFlowAsync({
                flowName: name,
                id: selectedFlowId,
              })
            );

            if (res.meta.requestStatus === 'fulfilled' && cloneFlow.data) {
              navigate(`/flows/${cloneFlow.data}/edit`);
            }
          }}
          isLoading={cloneFlow.status === 'loading'}
        />
      )}
    </>
  );
};

export default FlowsV2Page;
